import config from "../../../../config";

const baseUrl = config("magickraumBaseUrls")[1];

const makeWorkThumbnail = (remoteKey, workId) => {
  const last4 = workId.substr(-4);
  const secret = `${remoteKey}.${last4}`;

  return `${baseUrl}/image.${secret}/flat,600x600,075,f.jpg`;
};

export default makeWorkThumbnail;
